import classNames from 'classnames';
import { observer } from 'mobx-react';

import style from './TaskRightMenuTitle.module.scss';
import '@components/mixins/commonStyles.scss';

import { FrontendDictionaryNames, FrontendTaskStatus } from 'chaika-frontend-types/frontend-cms';

import { isDefined } from '@utils/isDefined';
import { store } from '@store';
import { useTaskForm } from '@common/Task/TaskRightMenu/context/TaskFormContext';
import { TaskUrgencyBadge } from './TaskUrgencyBadge';
import { TaskStatusBadge } from './TaskStatusBadge';
import { translate } from '@chaika/i18n/helper';

export const TaskRightMenuTitle = observer((): React.ReactElement<any> => {
    const { state } = useTaskForm();
    const { status, urgency, isEditMode, type } = state;
    const isNew = status === FrontendTaskStatus.Draft;
    const taskTypes = store.dictionary.getDictionary(FrontendDictionaryNames.TaskType);
    const typeTitle = isDefined(type) ? taskTypes.getByValue(type)?.title : undefined;

    return (
        <div className={style.root}>
            <div className={style.marks}>
                {status && <TaskStatusBadge status={status} />}
                <TaskUrgencyBadge urgency={urgency} />
            </div>
            <div className={classNames(['font_h1', style.title])}>{getTitle(isNew, isEditMode, typeTitle)}</div>
        </div>
    );
});

function getTitle(isNew: boolean, isEditMode: boolean, typeTitle?: string): string {
    if (isNew) {
        return translate('newTask');
    }

    if (isEditMode) {
        return translate('taskEditing');
    }

    return typeTitle ?? translate('task');
}
